export const LAYOUT_RIGHT = 'RIGHT';
export const LAYOUT_LEFT = 'LEFT';
